import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
var Parse = require("parse");

/**
 * Contains functions for calling and declaring
 *
 * @class Jobin.Chat
 * @static
 * @hideconstructor
 */

/**
 * Get the user chat conversations.
 * @method getUserChatConversations
 * @name Jobin.Chat.getUserChatConversations
 * @returns {Array} User chat conversations.
 */
export function getUserChatConversations() {
  return _getUserChatConversations.apply(this, arguments);
}
/**
 * Get the last message of a chat conversations.
 * @method getLastMessageForConversation
 * @name Jobin.Chat.getLastMessageForConversation
 * @param {ParseObject} chatConversation Conversation from which you want to get the last message
 * @returns {ParseObject} Last chat conversation message.
 */
function _getUserChatConversations() {
  _getUserChatConversations = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var currentUser, isJober, ChatConversation, query;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return Parse.User.currentAsync();
        case 2:
          currentUser = _context.sent;
          isJober = currentUser.get("Jober");
          ChatConversation = Parse.Object.extend("ChatConversations");
          query = new Parse.Query(ChatConversation);
          if (isJober) {
            //Diferent query variables if currentUser is a Jober or a Client
            query.equalTo("Jober", currentUser);
            query.include(["User.Name"]);
            query.include(["User.Thumbnail"]);
          } else {
            query.equalTo("User", currentUser);
            query.include(["Jober.Name"]);
            query.include(["Jober.Thumbnail"]);
          }
          query.include(["Job.Title"]);
          query.descending("createdAt");
          _context.prev = 9;
          _context.next = 12;
          return query.find();
        case 12:
          _context.t0 = _context.sent;
          return _context.abrupt("return", {
            status: "ok",
            result: _context.t0
          });
        case 16:
          _context.prev = 16;
          _context.t1 = _context["catch"](9);
          console.error(_context.t1);
          return _context.abrupt("return", {
            status: "error",
            result: "No hemos podido descargar tus conversaciones de chat. Inténtalo de nuevo más tarde."
          });
        case 20:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[9, 16]]);
  }));
  return _getUserChatConversations.apply(this, arguments);
}
export function getLastMessageForConversation(_x) {
  return _getLastMessageForConversation.apply(this, arguments);
}
/**
 * Get all the messages of a chat conversation and save them as read.
 * @method getMessagesForConversation
 * @name Jobin.Chat.getMessagesForConversation
 * @param {ParseObject} chatConversation Conversation from which you want to get the messages array
 * @returns {Array} Array with the chat conversation messages.
 */
function _getLastMessageForConversation() {
  _getLastMessageForConversation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(chatConversation) {
    var user, jober, job, ChatMessage, query;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          user = chatConversation.get("User");
          jober = chatConversation.get("Jober");
          job = chatConversation.get("Job");
          ChatMessage = Parse.Object.extend("ChatMessage");
          query = new Parse.Query(ChatMessage);
          query.include("sender", [user, jober]);
          query.include("recipient", [user, jober]);
          query.equalTo("job", job);
          query.descending("createdAt");
          _context2.prev = 9;
          _context2.next = 12;
          return query.first();
        case 12:
          _context2.t0 = _context2.sent;
          return _context2.abrupt("return", {
            status: "ok",
            result: _context2.t0
          });
        case 16:
          _context2.prev = 16;
          _context2.t1 = _context2["catch"](9);
          console.error(_context2.t1);
          return _context2.abrupt("return", {
            status: "error",
            result: "No se pudo obtener el último mensaje de la conversación"
          });
        case 20:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[9, 16]]);
  }));
  return _getLastMessageForConversation.apply(this, arguments);
}
export function getMessagesForConversation(_x2) {
  return _getMessagesForConversation.apply(this, arguments);
}
/**
 * Send and save message for chat conversation.
 * @method sendMessageForConversation
 * @name Jobin.Chat.sendMessageForConversation
 * @param {ParseObject} chatConversation Conversation to which the message belongs
 * @param {JobinMessage} message Message you want to send
 * @returns {boolean} Success.
 */
function _getMessagesForConversation() {
  _getMessagesForConversation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(chatConversation) {
    var user, jober, job, ChatMessage, query, result, i, message, recipient;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          user = chatConversation.get("User");
          jober = chatConversation.get("Jober");
          job = chatConversation.get("Job");
          ChatMessage = Parse.Object.extend("ChatMessage");
          query = new Parse.Query(ChatMessage);
          query.include("sender", [user, jober]);
          query.include("recipient", [user, jober]);
          query.equalTo("job", job);
          query.include(["sender.Thumbnail"]);
          query.descending("createdAt");
          _context3.prev = 10;
          _context3.next = 13;
          return query.find();
        case 13:
          result = _context3.sent;
          if (!result) {
            _context3.next = 27;
            break;
          }
          i = 0;
        case 16:
          if (!(i < result.length)) {
            _context3.next = 26;
            break;
          }
          message = result[i];
          recipient = message.get("recipient");
          if (!(message.get("read") === false && recipient.id === user.id)) {
            _context3.next = 23;
            break;
          }
          message.set("read", true);
          _context3.next = 23;
          return message.save();
        case 23:
          i++;
          _context3.next = 16;
          break;
        case 26:
          return _context3.abrupt("return", {
            status: "ok",
            result: result
          });
        case 27:
          _context3.next = 33;
          break;
        case 29:
          _context3.prev = 29;
          _context3.t0 = _context3["catch"](10);
          console.error(_context3.t0);
          return _context3.abrupt("return", {
            status: "ok",
            result: "Hubo un error y no hemos podido obtener los mensajes de esta conversación de chat"
          });
        case 33:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[10, 29]]);
  }));
  return _getMessagesForConversation.apply(this, arguments);
}
export function sendMessageForConversation(_x3, _x4) {
  return _sendMessageForConversation.apply(this, arguments);
}
function _sendMessageForConversation() {
  _sendMessageForConversation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(message, chatConversation) {
    var sender, isJober, job, recipient, imageFile, result, _result;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return Parse.User.currentAsync();
        case 2:
          sender = _context4.sent;
          isJober = sender.get("Jober");
          job = chatConversation.get("Job");
          recipient = null;
          if (isJober) {
            recipient = chatConversation.get("User");
          } else {
            recipient = chatConversation.get("Jober");
          }
          if (!message.image) {
            _context4.next = 35;
            break;
          }
          _context4.prev = 8;
          //Save image in Parse
          imageFile = new Parse.File("image.jpg", {
            base64: message.image
          });
          _context4.next = 12;
          return imageFile.save();
        case 12:
          _context4.prev = 12;
          _context4.next = 15;
          return Parse.Cloud.run("sendChatMessage", {
            type: "image",
            imageUrl: imageFile.url(),
            jobId: job.id,
            senderId: sender.id,
            recipientId: recipient.id
          });
        case 15:
          result = _context4.sent;
          if (!result) {
            _context4.next = 20;
            break;
          }
          return _context4.abrupt("return", {
            status: "ok",
            result: true
          });
        case 20:
          return _context4.abrupt("return", {
            status: "error",
            result: "Hubo un fallo y no hemos podido enviar tu mensaje. Inténtalo de nuevo más tarde."
          });
        case 21:
          _context4.next = 27;
          break;
        case 23:
          _context4.prev = 23;
          _context4.t0 = _context4["catch"](12);
          console.error(_context4.t0);
          return _context4.abrupt("return", {
            status: "error",
            result: "Hubo un fallo y no hemos podido enviar tu mensaje. Inténtalo de nuevo más tarde."
          });
        case 27:
          _context4.next = 33;
          break;
        case 29:
          _context4.prev = 29;
          _context4.t1 = _context4["catch"](8);
          console.error(_context4.t1);
          return _context4.abrupt("return", {
            status: "error",
            result: "Hubo un fallo y no hemos podido enviar tu mensaje. Inténtalo de nuevo más tarde."
          });
        case 33:
          _context4.next = 50;
          break;
        case 35:
          _context4.prev = 35;
          _context4.next = 38;
          return Parse.Cloud.run("sendChatMessage", {
            type: "message",
            text: message.text,
            jobId: job.id,
            senderId: sender.id,
            recipientId: recipient.id
          });
        case 38:
          _result = _context4.sent;
          if (!_result) {
            _context4.next = 43;
            break;
          }
          return _context4.abrupt("return", {
            status: "ok",
            result: true
          });
        case 43:
          return _context4.abrupt("return", {
            status: "error",
            result: "Hubo un fallo y no hemos podido enviar tu mensaje. Inténtalo de nuevo más tarde."
          });
        case 44:
          _context4.next = 50;
          break;
        case 46:
          _context4.prev = 46;
          _context4.t2 = _context4["catch"](35);
          console.info(_context4.t2);
          return _context4.abrupt("return", {
            status: "error",
            result: "Hubo un fallo y no hemos podido enviar tu mensaje. Inténtalo de nuevo más tarde."
          });
        case 50:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[8, 29], [12, 23], [35, 46]]);
  }));
  return _sendMessageForConversation.apply(this, arguments);
}